module.exports = __webpack_public_path__ + "img/shield.d2c28de4.png";